import { useLayoutEffect, useState } from 'react';

import { KEY_MYGPT_COMPLETIONS } from '@/constant';
import { randomId } from '@/utils/random';

export const useSessionId = (aiId?: string) => {
  const [uuid, setUuid] = useState(randomId());
  const LOCALSTORAGE_CHAT_KEY = `${KEY_MYGPT_COMPLETIONS}_${aiId}`;
  let chatSessionId;

  for (;;) {
    if (!aiId) break;
    const chatInfo = window.storageSupported ? localStorage.getItem(LOCALSTORAGE_CHAT_KEY) : null;
    if (!chatInfo) break;
    const info = JSON.parse(chatInfo);
    chatSessionId = info.sessionId;
    break;
  }

  const refreshId = () => {
    setUuid(randomId());
  };

  return {
    sessionId: chatSessionId || uuid,
    LOCALSTORAGE_CHAT_KEY,
    refreshId,
  };
};
